import { jsx as _jsx } from "react/jsx-runtime";
import { AlertDot } from '#pplx/frontend/aether/components/AlertDot/index.js';
import { useGetRecentItemsWithActiveStreams } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/useGetRecentItemsWithActiveStreams.js';
import { useSidebarV2 } from '#pplx/frontend/apps/ask/hooks/sidebar-graphql-v2/context.js';
import { COMPUTER_TASKS_HREF, isComputerTaskThreadRoute, } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/constants.js';
import { AUTOMATIONS_HREF, SESSIONS_HREF, useSidebarNavigationItems, } from '#pplx/frontend/apps/ask/layout/sidebar/navigation/useSidebarNavigationItems.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useMemo } from 'react';
const LazyAutomationsSidebarUnreadIndicator = Dynamic(async () => {
    const { AutomationsSidebarUnreadIndicator } = await import('#pplx/frontend/apps/ask/automations-shared/components/AutomationsSidebarUnreadIndicator.js');
    return { default: AutomationsSidebarUnreadIndicator };
});
export function useLegacySidebarNavigationItems(options) {
    const items = useSidebarNavigationItems(options);
    const sidebar = useSidebarV2();
    const { isIncognito, isAuthenticated } = options;
    const { data: recentThreads } = useGetRecentItemsWithActiveStreams({
        reason: 'sidebar-unread-indicator',
        graphQLSource: sidebar?.recents,
        filter: sidebar?.recentsFilter,
        excludeAsi: false,
    });
    const hasUnreadComputerThreads = useMemo(() => !isIncognito &&
        recentThreads.some((thread) => thread.sidebarItemType !== 'automation' &&
            !thread.hasCron &&
            thread.unread === true &&
            isComputerTaskThreadRoute(thread.link)), [isIncognito, recentThreads]);
    // Sessions lists every recent session, automations included, so any unread one counts.
    const hasUnreadSessions = useMemo(() => !isIncognito && recentThreads.some((thread) => thread.unread === true), [isIncognito, recentThreads]);
    return useMemo(() => items.map((item) => {
        if (item.href === COMPUTER_TASKS_HREF) {
            return {
                ...item,
                iconBadge: hasUnreadComputerThreads ? (_jsx(AlertDot, { size: "sm", ringColor: "subtle", "data-testid": "computer-unread-dot" })) : null,
            };
        }
        if (item.href === SESSIONS_HREF) {
            return {
                ...item,
                iconBadge: hasUnreadSessions ? (_jsx(AlertDot, { size: "sm", ringColor: "subtle", "data-testid": "sessions-unread-dot" })) : null,
            };
        }
        if (item.href === AUTOMATIONS_HREF) {
            return {
                ...item,
                iconBadge: isAuthenticated && !isIncognito ? _jsx(LazyAutomationsSidebarUnreadIndicator, {}) : null,
            };
        }
        return item;
    }), [items, hasUnreadComputerThreads, hasUnreadSessions, isAuthenticated, isIncognito]);
}
//# sourceMappingURL=useLegacySidebarNavigationItems.js.map